import React, { useCallback, useState } from "react";
import shortid from "shortid";
import { Form, Button, Input, InputGroup } from "reactstrap";
import type { DashboardTodo } from "./Todo";

export default function TodoForm({
  onSubmit
}: {
  onSubmit: (todo: DashboardTodo) => void;
}) {
  const [text, setText] = useState("");

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setText(event.target.value);
    },
    []
  );

  const handleSubmit = useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();
      const trimmed = text.trim();
      if (!trimmed) return;
      onSubmit({
        id: shortid.generate(),
        text: trimmed,
        complete: false
      });
      setText("");
    },
    [onSubmit, text]
  );

  return (
    <Form onSubmit={handleSubmit} className="dashboard-task-form mb-3">
      <InputGroup className="dashboard-task-form__group">
        <Input
          name="text"
          value={text}
          onChange={handleChange}
          placeholder="Add a task…"
          className="form-control-sm"
          bsSize="sm"
        />
        <Button
          type="submit"
          color="primary"
          size="sm"
          className="dashboard-task-form__add"
        >
          Add
        </Button>
      </InputGroup>
    </Form>
  );
}
